<div class="bg-gray-50 min-h-screen p-6">
  <div class="max-w-7xl mx-auto">
    <h1 class="text-3xl font-bold text-gray-800 mb-8">Catégories de matériaux</h1>
    
    <!-- Message d'erreur global -->
    <div *ngIf="error" class="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
      <div class="flex items-center justify-between">
        <p class="text-red-700">{{ error }}</p>
        <button (click)="clearError()" class="text-red-500 hover:text-red-700">
          <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
          </svg>
        </button>
      </div>
    </div>
    
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <!-- Section Nouvelle catégorie -->
      <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <h2 class="text-xl font-semibold text-gray-700 mb-6">Nouvelle catégorie</h2>
        
        <div class="space-y-4">
          <!-- Libellé -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Libellé <span class="text-red-500">*</span>
            </label>
            <input
              type="text"
              [(ngModel)]="nouvelleCategorie.label"
              (input)="onFormInput('label')"
              (keydown)="onKeyDown($event, 'add')"
              placeholder="Ex: Équipements de sécurité"
              class="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent text-gray-700"
              [class.border-red-300]="hasError('label')"
              [class.border-gray-300]="!hasError('label')"
            />
            <p *ngIf="hasError('label')" class="mt-1 text-sm text-red-600">{{ getError('label') }}</p>
          </div>
          
          <!-- Code -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Code <span class="text-red-500">*</span>
            </label>
            <input
              type="text"
              [(ngModel)]="nouvelleCategorie.code"
              (input)="onFormInput('code')"
              (keydown)="onKeyDown($event, 'add')"
              placeholder="Ex: EQUIP_SEC"
              class="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent text-gray-700 uppercase"
              [class.border-red-300]="hasError('code')"
              [class.border-gray-300]="!hasError('code')"
            />
            <p *ngIf="hasError('code')" class="mt-1 text-sm text-red-600">{{ getError('code') }}</p>
            <p class="mt-1 text-xs text-gray-500">Lettres, chiffres et underscores uniquement</p>
          </div>
          
          <!-- Options de date -->
          <div class="space-y-3">
            <div class="flex items-center">
              <input
                type="checkbox"
                id="hasStartDate"
                [(ngModel)]="nouvelleCategorie.hasStartDate"
                class="w-4 h-4 text-orange-600 bg-gray-100 border-gray-300 rounded focus:ring-orange-500"
              />
              <label for="hasStartDate" class="ml-2 text-sm font-medium text-gray-700">
                Possède une date de début
              </label>
            </div>
            
            <div class="flex items-center">
              <input
                type="checkbox"
                id="hasEndDate"
                [(ngModel)]="nouvelleCategorie.hasEndDate"
                class="w-4 h-4 text-orange-600 bg-gray-100 border-gray-300 rounded focus:ring-orange-500"
              />
              <label for="hasEndDate" class="ml-2 text-sm font-medium text-gray-700">
                Possède une date de fin
              </label>
            </div>
          </div>
          
          <!-- Bouton Ajouter -->
          <button
            (click)="ajouterCategorie()"
            [disabled]="isSubmitting || !nouvelleCategorie.label.trim() || !nouvelleCategorie.code.trim()"
            class="w-full bg-orange-500 hover:bg-orange-600 disabled:bg-gray-300 disabled:cursor-not-allowed text-white font-medium py-2.5 px-4 rounded-md transition-colors duration-200 flex items-center justify-center"
          >
            <svg *ngIf="isSubmitting" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {{ isSubmitting ? 'Ajout en cours...' : 'Ajouter' }}
          </button>
        </div>
      </div>
      
      <!-- Section Liste des catégories -->
      <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div class="flex items-center justify-between mb-6">
          <h2 class="text-xl font-semibold text-gray-700">Liste des catégories</h2>
          
          <!-- Informations de pagination -->
          <div *ngIf="getTotalElements() > 0" class="text-sm text-gray-500">
            {{ getTotalElements() }} catégorie{{ getTotalElements() > 1 ? 's' : '' }}
            (Page {{ getCurrentPage() }}/{{ getTotalPages() }})
          </div>
        </div>
        
        <!-- Barre de recherche -->
        <div class="mb-4">
          <div class="relative">
            <input
              type="text"
              [(ngModel)]="searchTerm"
              (input)="onSearchChange($event)"
              placeholder="Rechercher une catégorie..."
              class="w-full px-4 py-2 pl-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
            />
            <svg class="w-4 h-4 text-gray-400 absolute left-3 top-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
            <button *ngIf="searchTerm" (click)="clearSearch()" class="absolute right-3 top-2.5 text-gray-400 hover:text-gray-600">
              <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
              </svg>
            </button>
          </div>
        </div>
        
        <!-- Indicateur de chargement -->
        <div *ngIf="isLoading" class="flex items-center justify-center py-8">
          <svg class="animate-spin h-8 w-8 text-orange-500" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <span class="ml-2 text-gray-600">Chargement...</span>
        </div>
        
        <!-- Liste des catégories -->
        <div *ngIf="!isLoading" class="space-y-3">
          <div 
            *ngFor="let category of categories; trackBy: trackByCategory" 
            class="flex items-center justify-between py-3 px-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors duration-150"
          >
            <!-- Contenu (mode normal) -->
            <div *ngIf="!isEditing(category)" class="flex-1">
              <div class="flex items-center justify-between">
                <div>
                  <span class="text-gray-800 font-medium">{{ category.label }}</span>
                  <span class="ml-2 px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded">{{ category.code }}</span>
                </div>
                <div class="flex items-center space-x-1 text-xs text-gray-500">
                  <span *ngIf="category.hasStartDate" class="px-2 py-1 bg-blue-100 text-blue-700 rounded">Date début</span>
                  <span *ngIf="category.hasEndDate" class="px-2 py-1 bg-green-100 text-green-700 rounded">Date fin</span>
                </div>
              </div>
            </div>
            
            <!-- Contenu (mode édition) -->
            <div *ngIf="isEditing(category)" class="flex-1 mr-3 space-y-3">
              <!-- Libellé -->
              <div>
                <input
                  type="text"
                  [(ngModel)]="editForm.label"
                  (input)="onFormInput('label')"
                  (keydown)="onKeyDown($event, 'save')"
                  class="w-full px-3 py-1.5 border rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent text-gray-700"
                  [class.border-red-300]="hasError('label')"
                  [class.border-gray-300]="!hasError('label')"
                  placeholder="Libellé"
                />
                <p *ngIf="hasError('label')" class="mt-1 text-xs text-red-600">{{ getError('label') }}</p>
              </div>
              
              <!-- Code -->
              <div>
                <input
                  type="text"
                  [(ngModel)]="editForm.code"
                  (input)="onFormInput('code')"
                  (keydown)="onKeyDown($event, 'save')"
                  class="w-full px-3 py-1.5 border rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent text-gray-700 uppercase"
                  [class.border-red-300]="hasError('code')"
                  [class.border-gray-300]="!hasError('code')"
                  placeholder="CODE"
                />
                <p *ngIf="hasError('code')" class="mt-1 text-xs text-red-600">{{ getError('code') }}</p>
              </div>
              
              <!-- Options de date -->
              <div class="flex space-x-4">
                <label class="flex items-center text-sm">
                  <input
                    type="checkbox"
                    [(ngModel)]="editForm.hasStartDate"
                    class="w-3 h-3 text-orange-600 bg-gray-100 border-gray-300 rounded focus:ring-orange-500"
                  />
                  <span class="ml-1">Date début</span>
                </label>
                
                <label class="flex items-center text-sm">
                  <input
                    type="checkbox"
                    [(ngModel)]="editForm.hasEndDate"
                    class="w-3 h-3 text-orange-600 bg-gray-100 border-gray-300 rounded focus:ring-orange-500"
                  />
                  <span class="ml-1">Date fin</span>
                </label>
              </div>
            </div>
            
            <!-- Actions (mode normal) -->
            <div *ngIf="!isEditing(category)" class="flex items-center space-x-2">
              <!-- Bouton Modifier -->
              <button 
                (click)="modifierCategorie(category)"
                class="p-1.5 text-orange-400 hover:text-orange-600 hover:bg-orange-50 rounded transition-colors duration-150"
                title="Modifier"
              >
                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"></path>
                </svg>
              </button>
              
              <!-- Bouton Supprimer -->
              <button 
                (click)="supprimerCategorie(category.id!)"
                class="p-1.5 text-red-400 hover:text-red-600 hover:bg-red-50 rounded transition-colors duration-150"
                title="Supprimer"
              >
                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                </svg>
              </button>
            </div>
            
            <!-- Actions (mode édition) -->
            <div *ngIf="isEditing(category)" class="flex items-center space-x-2">
              <!-- Bouton Sauvegarder -->
              <button 
                (click)="sauvegarderModification()"
                [disabled]="!editForm.label.trim() || !editForm.code.trim()"
                class="p-1.5 text-green-500 hover:text-green-600 hover:bg-green-50 rounded transition-colors duration-150 disabled:text-gray-400 disabled:cursor-not-allowed"
                title="Sauvegarder"
              >
                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
                </svg>
              </button>
              
              <!-- Bouton Annuler -->
              <button 
                (click)="annulerModification()"
                (keydown)="onKeyDown($event, 'cancel')"
                class="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-50 rounded transition-colors duration-150"
                title="Annuler"
              >
                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
                </svg>
              </button>
            </div>
          </div>
          
          <!-- Bouton Charger plus -->
          <div *ngIf="canLoadMore()" class="text-center pt-4">
            <button
              (click)="loadMoreCategories()"
              [disabled]="isLoadingMore"
              class="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md transition-colors duration-200 disabled:opacity-50"
            >
              <svg *ngIf="isLoadingMore" class="animate-spin -ml-1 mr-2 h-4 w-4 text-gray-700 inline" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              {{ isLoadingMore ? 'Chargement...' : 'Charger plus' }}
            </button>
          </div>
          
          <!-- Message si aucune catégorie -->
          <div *ngIf="categories.length === 0 && !isLoading" class="text-center py-8 text-gray-500">
            <svg class="w-12 h-12 mx-auto mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"></path>
            </svg>
            <p>{{ searchTerm ? 'Aucune catégorie trouvée pour cette recherche' : 'Aucune catégorie trouvée' }}</p>
            <p class="text-sm">{{ searchTerm ? 'Essayez avec d\'autres mots-clés' : 'Ajoutez votre première catégorie de matériaux' }}</p>
          </div>
        </div>
        
        <!-- Bouton Actualiser -->
        <div class="mt-6 text-center">
          <button
            (click)="refreshCategories()"
            class="inline-flex items-center px-3 py-2 text-sm text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-md transition-colors duration-200"
          >
            <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
            </svg>
            Actualiser
          </button>
        </div>
      </div>
    </div>
  </div>
</div>